import Store from "../store/store";
import CartItem from "./../classes/CartItem";

export default class ServiceQuote {
    constructor(serviceData) {

        for (const i in serviceData) {
            this[i] = serviceData[i];
        }

        this.title = this.name;
        this.user = Store.state.user;
        this.itemId = this.getRandomId();
        this.deliveryLabel = ServiceQuote.getDeliveryLabel(this.max_delivery_days)
    }

    static getDeliveryLabel(maxDays) {
        return `${maxDays} Days`
    }

    static makeArray(kitsData) {
        return kitsData.map(kit => new ServiceQuote(kit));
    }

    get tagsFormatted() {
        return this.tags.map((tag) => ({...tag, name: `#${tag.name}`}))
    }

    get tagsStringFormatted() {
        return this.tags.map((tag) => `#${tag.name}`).join(' ')
    }

    get license() {
        return {
            name: `${this.name} License`,
            contract: {
                clean: this.agreement?.agreement_text,
            }
        }
    }

    image(size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size];
        }
        return this.user.avatar.files[size];
    }

    addToCart() {
        Store.state.cart.addItem(new CartItem(this, this.license, this.price, this.getType()))
    }

    inCart(productPricing = null) {
        return Store.state.cart.inCart(this);
    }

    play() {
    }

    pause() {
    }

    getType() {
        return "service_quote";
    }

    shareUrl() {
        return `${ab.baseUrl}/services/${this.service_id}`;
    }

    minPrice() {
        return this.price;
    }

    maxPrice() {
        return this.price;
    }

    playTag() {
        return false;
    }

    isBeat() {
        return false;
    }

    isSong() {
        return false;
    }

    isSoundKit() {
        return true;
    }

    isCollection() {
        return false;
    }

    getRandomId() {
        let number = Math.random();
        number.toString(36);
        return number.toString(36).substr(2, 9);
    }

    notPlayable() {
        return true
    }
}
